import { ROLE_ADMIN, ROLE_AGENT, ROLE_CLIENT, ROLE_MANAGER } from '@/consts/app'
import {
  ACCOUNT_RIGHT_CREATE_SELF_REQUEST,
  ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS,
  ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT,
  ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER,
  ACCOUNT_RIGHT_LIST_AGENT_HOURS,
  ACCOUNT_RIGHT_LIST_AGENTS,
  ACCOUNT_RIGHT_LIST_CHECKPOINTS,
  ACCOUNT_RIGHT_LIST_CUSTOMERS,
  ACCOUNT_RIGHT_LIST_ESTIMATES,
  ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS,
  ACCOUNT_RIGHT_LIST_INVOICES,
  ACCOUNT_RIGHT_LIST_MISSION_EVENTS,
  ACCOUNT_RIGHT_LIST_MISSIONS,
  ACCOUNT_RIGHT_LIST_REQUESTS,
  ACCOUNT_RIGHT_LIST_ROUNDS,
  ACCOUNT_RIGHT_LIST_SITES,
  ACCOUNT_RIGHT_LIST_UNAVAILABILITIES,
  ACCOUNT_RIGHT_READ_AGENTS_PLANNING,
  ACCOUNT_RIGHT_READ_DASHBOARD,
  ACCOUNT_RIGHT_READ_EMAIL_TRACKING,
  ACCOUNT_RIGHT_READ_SHARED_DOCUMENTS,
  ACCOUNT_RIGHT_READ_SITES_PLANNING,
  ACCOUNT_RIGHT_READ_SUPERVISION_TRACKING
} from '@/consts/rights'
import adminPlanning, {
  ROUTE_NAME_PLATFORM_PLANNING_AGENTS,
  ROUTE_NAME_PLATFORM_PLANNING_SITE
} from '@/router/platform/adminPlanning'
import store from '@/store'
import customerPlanning from '@/router/platform/customerPlanning'
import Resume from 'pages/Admin/Resume'
import TrackingEmails from 'pages/Platform/TrackingEmails'
import ParamsAgencyCatalogServices from 'pages/Platform/Params/ParamsAgencyCatalogServices'
import { routeBadgeRequestUnread } from '@/utils/routing'
import Contracts from 'pages/Platform/Contracts/Contracts'
import routeContracts, {
  ROUTE_NAME_PLATFORM_CONTRACTS_AGENT,
  ROUTE_NAME_PLATFORM_CONTRACTS_CUSTOMER
} from '@/router/platform/routeContracts'

const SimpleRouteWrapper = () => import(/* webpackChunkName: "app-platform" */'@/router/SimpleRouteWrapper')
const PlanningAgents = () => import(/* webpackChunkName: "app-platform" */'@/pages/Platform/Planning/PlanningAgents')
const DashBoard = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/DashBoard')
const Planning = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Planning')
const Services = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Services')
const MainsCourantes = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/MainsCourantes')
const Agents = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Agents')
const Administrateurs = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Administrateurs')
const Indisponibilites = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Indisponibilites')
const Customers = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Customers')
const Demandes = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Demandes')
const Documents = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Documents')
const DocumentsClients = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/DocumentsClients')
const Marges = () => import(/* webpackChunkName: "sekur-platform" */'pages/Platform/Marges')
const Sites = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Sites')
const Rondes = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Rondes')
const Checkpoints = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Checkpoints')
const Devis = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Estimates')
const Invoices = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Invoices')
const ExportDesDonnees = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/ExportDesDonnees')
const InterventionReports = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/InterventionReports')
const Supervision = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Supervision')
const AdminDashBoard = () => import(/* webpackChunkName: "app-platform" */'pages/Admin/Turnover')
const HoursAgent = () => import(/* webpackChunkName: "sekur-platform" */'pages/Platform/HoursAgent')
const AgentsHours = () => import(/* webpackChunkName: "sekur-platform" */'pages/Platform/AgentsHours')
const Abonnements = () => import(/* webpackChunkName: "sekur-platform" */'pages/Platform/Abonnements')
const SigningContract = () => import(/* webpackChunkName: "sekur-platform" */'pages/Platform/SigningContract')

export const ROUTE_NAME_PLATFORM_DASHBOARD = 'platformServiceAdminDashboard'
export const ROUTE_NAME_PLATFORM_SERVICE_EVENTS = 'platformServiceAdminMc'
export const ROUTE_NAME_PLATFORM_MY_PLANNING_AGENT = 'platformMyPlanningAgent'
export const ROUTE_NAME_PLATFORM_ADMIN_DASHBOARD_CA = 'platformAdminDashBoardCA'
export const ROUTE_NAME_PLATFORM_ADMIN_DASHBOARD_RESUME = 'platformAdminDashBoardResume'
export const ROUTE_NAME_PLATFORM_AGENT_REQUESTS = 'platformAgentRequests'

export default [
  {
    path: 'platform/admin/dashboard',
    name: 'platformAdminDashboard',
    component: SimpleRouteWrapper,
    meta: {
      label: `Tableau de bord ${process.env.APP.name}`,
      group: true,
      roles: [ROLE_ADMIN],
      icon: 'fa fa-tachometer-alt',
      mode: ['platform']
    },
    children: [
      {
        path: 'ca-sekur',
        name: ROUTE_NAME_PLATFORM_ADMIN_DASHBOARD_CA,
        component: AdminDashBoard,
        meta: {
          label: 'Chiffres d\'affaires',
          icon: 'fa fa-tachometer-alt',
          roles: [ROLE_ADMIN]
        }
      },
      {
        path: 'resume-sekur',
        name: ROUTE_NAME_PLATFORM_ADMIN_DASHBOARD_RESUME,
        component: Resume,
        meta: {
          label: `Resumé ${process.env.APP.name}`,
          icon: 'fa fa-tachometer-alt',
          roles: [ROLE_ADMIN]
        }
      }
    ]
  },
  {
    path: 'my-planning',
    component: Planning,
    redirect: ROUTE_NAME_PLATFORM_MY_PLANNING_AGENT,
    meta: {
      label: 'Mon planning',
      roles: [ROLE_AGENT],
      icon: 'far fa-calendar-alt',
      mode: ['platform']
    },
    children: [
      {
        path: '',
        name: ROUTE_NAME_PLATFORM_MY_PLANNING_AGENT,
        component: PlanningAgents,
        meta: {
          roles: [ROLE_AGENT]
        }
      }
    ]
  },
  {
    path: 'hoursAgent',
    name: 'terrainHoursAgentList',
    component: HoursAgent,
    meta: {
      label: 'Mes heures supplémentaires',
      icon: 'fa fa-user-clock',
      roles: [ROLE_AGENT],
      isGranted: [
        ACCOUNT_RIGHT_LIST_AGENT_HOURS
      ]
    }
  },
  {
    path: 'platform/service',
    name: 'platformService',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Gestion',
      group: true,
      roles: [ROLE_MANAGER, ROLE_AGENT],
      icon: 'far fa-calendar-alt',
      mode: ['platform']
    },
    children: [
      {
        path: 'adminDashboard',
        name: ROUTE_NAME_PLATFORM_DASHBOARD,
        component: DashBoard,
        meta: {
          label: 'Tableau de bord',
          icon: 'fa fa-tachometer-alt',
          isGranted: [
            ACCOUNT_RIGHT_READ_DASHBOARD
          ]
        }
      },
      {
        path: 'adminPlanning',
        name: 'platformServiceAdminPlanning',
        component: Planning,
        redirect: () => ({
          name: store.getters['user/isGranted'](ACCOUNT_RIGHT_READ_SITES_PLANNING)
            ? ROUTE_NAME_PLATFORM_PLANNING_SITE
            : ROUTE_NAME_PLATFORM_PLANNING_AGENTS
        }),
        meta: {
          label: 'Planning',
          icon: 'fa fa-calendar-day',
          roles: [ROLE_MANAGER, ROLE_AGENT],
          isGranted: [
            ACCOUNT_RIGHT_READ_SITES_PLANNING,
            ACCOUNT_RIGHT_READ_AGENTS_PLANNING
          ]
        },
        children: adminPlanning
      },
      {
        path: 'adminServices',
        name: 'platformServiceAdminServices',
        props: true,
        component: Services,
        meta: {
          label: 'Services',
          icon: 'fa fa-clipboard-list',
          roles: [ROLE_MANAGER, ROLE_AGENT],
          isGranted: [
            ACCOUNT_RIGHT_LIST_MISSIONS
          ]
        }
      },
      {
        path: 'listIndispo',
        name: 'platformAgentsListIndispo',
        component: Indisponibilites,
        meta: {
          label: 'Indisponibilités',
          icon: 'fa fa-user-alt-slash',
          isGranted: [
            ACCOUNT_RIGHT_LIST_UNAVAILABILITIES
          ]
        }
      },
      {
        path: 'export',
        name: 'platformAgentsExport',
        component: ExportDesDonnees,
        meta: {
          label: 'Export des données',
          icon: 'fa fa-cloud-download-alt',
          roles: [ROLE_MANAGER]
        }
      },
      {
        path: 'agents-hours',
        name: 'platformAgencyAgentsHours',
        component: AgentsHours,
        meta: {
          label: 'Heures des agents',
          icon: 'fa fa-user-clock',
          roles: [ROLE_MANAGER]
        }
      },
      {
        path: 'demandes/:id?',
        name: ROUTE_NAME_PLATFORM_AGENT_REQUESTS,
        component: Demandes,
        props: true,
        meta: {
          label: 'Demandes',
          icon: 'fa fa-comment-dots',
          roles: [ROLE_MANAGER, ROLE_AGENT],
          badge: routeBadgeRequestUnread,
          isGranted: [
            ACCOUNT_RIGHT_CREATE_SELF_REQUEST,
            ACCOUNT_RIGHT_LIST_REQUESTS
          ]
        }
      },
      {
        path: 'documents',
        name: 'platformAgentDocuments',
        component: Documents,
        props: true,
        meta: {
          label: 'Documents',
          icon: 'fas fa-clipboard',
          roles: [ROLE_AGENT]
        }
      },
      {
        path: 'email-tracking',
        name: 'platformAgencyEmailTracking',
        component: TrackingEmails,
        meta: process.env.APP.app.showModules.emailTracking
          ? {
            label: 'Suivi des emails',
            icon: 'fa fa-envelope-open-text',
            isGranted: [
              ACCOUNT_RIGHT_READ_EMAIL_TRACKING
            ]
          }
          : null
      },
      {
        path: 'marges',
        name: 'platformMarges',
        component: Marges,
        props: true,
        meta: {
          label: 'Marges',
          roles: [ROLE_MANAGER, ROLE_AGENT],
          isGranted: [
            ACCOUNT_RIGHT_LIST_INVOICES // Factures
          ],
          icon: 'fas fa-chart-pie'
        }
      },
      {
        path: 'contracts',
        name: 'platformContracts',
        component: Contracts,
        redirect: () => ({
          name: store.getters['user/isGranted'](ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER)
            ? ROUTE_NAME_PLATFORM_CONTRACTS_CUSTOMER
            : ROUTE_NAME_PLATFORM_CONTRACTS_AGENT
        }),
        meta: {
          label: 'Contrats',
          icon: 'fa fa-file-contract',
          roles: [ROLE_MANAGER, ROLE_AGENT],
          isGranted: [
            ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER,
            ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT
          ]
        },
        children: routeContracts
      }
    ]
  },
  {
    path: 'platform/terrain',
    name: 'platformTerrain',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Terrain',
      group: true,
      roles: [ROLE_MANAGER, ROLE_AGENT],
      icon: 'fa fa-globe-europe',
      mode: ['platform']
    },
    children: [
      {
        path: 'adminMc',
        name: ROUTE_NAME_PLATFORM_SERVICE_EVENTS,
        component: MainsCourantes,
        meta: {
          label: 'Mains courantes',
          icon: 'fa fa-pen-nib',
          isGranted: [
            ACCOUNT_RIGHT_LIST_MISSION_EVENTS
          ]
        }
      },
      {
        path: 'bonInter',
        name: 'platformTerrainBonInter',
        component: InterventionReports,
        meta: {
          label: `Bons d'interventions`,
          icon: 'fa fa-tasks',
          isGranted: [
            ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS
          ]
        }
      },
      {
        path: 'supervision',
        name: 'platformTerrainSupervision',
        component: Supervision,
        meta: {
          label: 'Supervision',
          icon: 'fa fa-globe-europe',
          isGranted: [
            ACCOUNT_RIGHT_READ_SUPERVISION_TRACKING
          ]
        }
      },
      {
        path: 'rounds',
        name: 'platformAgencyRounds',
        component: Rondes,
        meta: {
          label: 'Rondes',
          icon: 'fa fa-route',
          isGranted: [
            ACCOUNT_RIGHT_LIST_ROUNDS
          ]
        }
      },
      {
        path: 'checkpoints',
        name: 'platformAgencyCheckpoints',
        component: Checkpoints,
        meta: {
          label: 'Points de contrôle',
          icon: 'fa fa-map-marker-alt',
          isGranted: [
            ACCOUNT_RIGHT_LIST_CHECKPOINTS
          ]
        }
      }
    ]
  },
  // {
  //   path: 'platform/agents',
  //   name: 'platformAgents',
  //   component: SimpleRouteWrapper,
  //   meta: {
  //     label: 'Utilisateurs',
  //     group: true,
  //     roles: [ROLE_MANAGER],
  //     icon: 'fa fa-users',
  //     mode: ['platform']
  //   },
  //   children: [
  //   ]
  // },
  {
    path: 'platform/agency',
    name: 'platformAgency',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Agence',
      group: true,
      roles: [ROLE_MANAGER, ROLE_AGENT],
      icon: 'fa fa-city',
      mode: ['platform']
    },
    children: [
      {
        path: 'customers',
        name: 'platformAgencyCustomers',
        component: Customers,
        meta: {
          label: 'Clients',
          icon: 'fa fa-user-tie',
          isGranted: [ACCOUNT_RIGHT_LIST_CUSTOMERS]
        }
      },
      {
        path: 'sites',
        name: 'platformAgencySites',
        component: Sites,
        meta: {
          label: 'Sites',
          icon: 'fa fa-building',
          isGranted: [
            ACCOUNT_RIGHT_LIST_SITES // Sites
          ]
        }
      },
      {
        path: 'agents',
        name: 'platformAgentsList',
        component: Agents,
        meta: {
          label: 'Agents',
          icon: 'fa fa-user-shield',
          isGranted: [
            ACCOUNT_RIGHT_LIST_AGENTS // Agents
          ]
        }
      },
      {
        path: 'admins',
        name: 'platformAgentsListAdmin',
        component: Administrateurs,
        meta: {
          label: 'Administrateurs',
          icon: 'fa fa-user-cog',
          isGranted: () => store.getters['user/isAgencyOwner']
        }
      }
    ]
  },
  {
    path: 'platform/documents',
    name: 'platformDocuments',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Facturation',
      group: true,
      roles: [ROLE_MANAGER, ROLE_AGENT],
      icon: 'fa fa-file',
      mode: ['platform']
    },
    children: [
      {
        path: 'serviceCatalog',
        name: 'platformServiceCatalog',
        props: true,
        component: ParamsAgencyCatalogServices,
        meta: {
          label: `Catalogue d'articles`,
          icon: 'fa fa-book',
          roles: [ROLE_MANAGER, ROLE_AGENT],
          isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS]
        }
      },
      {
        path: 'devis',
        name: 'platformDocumentsDevis',
        props: true,
        component: Devis,
        meta: {
          label: 'Devis',
          icon: 'fa fa-file-invoice',
          isGranted: [
            ACCOUNT_RIGHT_LIST_ESTIMATES // Devis
          ]
        }
      },
      {
        path: 'factures',
        name: 'platformDocumentsFactures',
        component: Invoices,
        meta: {
          label: 'Factures',
          icon: 'fa fa-file-invoice-dollar',
          isGranted: [
            ACCOUNT_RIGHT_LIST_INVOICES // Factures
          ]
        }
      },
      {
        path: 'abonnements',
        name: 'platformDocumentsAbonnements',
        component: Abonnements,
        meta: {
          label: 'Abonnements',
          icon: 'fa fa-file-invoice-dollar',
          isGranted: [
            ACCOUNT_RIGHT_LIST_INVOICES // Factures
          ]
        }
      }
    ]
  },
  // ROUTES SPÉCIFIQUES AU CLIENT
  {
    path: 'customerDashboard',
    name: 'customerDashboard',
    component: DashBoard,
    meta: {
      label: 'Tableau de bord',
      icon: 'fa fa-tachometer-alt',
      roles: [ROLE_CLIENT],
      mode: ['platform']
    }
  },
  {
    path: 'customerPlanning',
    name: 'platformServiceCustomerPlanning',
    component: Planning,
    redirect: { name: 'customerPlaningSites' },
    meta: {
      label: 'Planning',
      icon: 'fa fa-calendar-day',
      isGranted: [ACCOUNT_RIGHT_READ_SITES_PLANNING],
      roles: [ROLE_CLIENT],
      mode: ['platform']
    },
    children: customerPlanning
  },
  {
    path: 'customerServices',
    name: 'platformServiceCustomerServices',
    component: Services,
    meta: {
      label: 'Services',
      icon: 'fa fa-clipboard-list',
      roles: [ROLE_CLIENT],
      isGranted: [ACCOUNT_RIGHT_READ_SITES_PLANNING],
      mode: ['platform']
    }
  },
  {
    path: 'customerMc',
    name: 'platformCustomerMc',
    component: MainsCourantes,
    meta: {
      label: 'Mains courantes',
      icon: 'fa fa-pen-nib',
      roles: [ROLE_CLIENT],
      isGranted: [ACCOUNT_RIGHT_LIST_MISSION_EVENTS],
      mode: ['platform']
    }
  },
  {
    path: 'documents',
    name: 'platformCustomerDocuments',
    component: DocumentsClients,
    meta: {
      label: 'Documents',
      icon: 'fas fa-clipboard',
      roles: [ROLE_CLIENT],
      isGranted: [ACCOUNT_RIGHT_READ_SHARED_DOCUMENTS],
      mode: ['platform']
    }
  },
  {
    path: 'customerInterventionReports',
    name: 'platformCustomerInterventionReports',
    component: InterventionReports,
    meta: {
      label: `Bons d'interventions`,
      icon: 'fa fa-tasks',
      roles: [ROLE_CLIENT],
      isGranted: [
        ACCOUNT_RIGHT_LIST_INTERVENTION_REPORTS
      ],
      mode: ['platform']
    }
  },
  {
    path: 'customerSites',
    name: 'platformAgencyCustomerSites',
    component: Sites,
    meta: {
      label: 'Sites',
      icon: 'fa fa-building',
      roles: [ROLE_CLIENT],
      mode: ['platform']
    }
  },
  {
    path: 'customerInvoices',
    name: 'platformCustomerDocumentsInvoices',
    component: Invoices,
    meta: {
      label: 'Factures',
      icon: 'fa fa-file-invoice-dollar',
      isGranted: [ACCOUNT_RIGHT_LIST_INVOICES],
      roles: [ROLE_CLIENT],
      mode: ['platform']
    }
  },
  {
    path: 'signature/:type/:id/:token',
    name: 'platformContractSigning',
    component: SigningContract,
    props: true
  }
]
